// extracted by mini-css-extract-plugin
export default {"gallery":"gallery_gallery__v632-","color":"gallery_color__OFCg0","gallery1":"gallery_gallery1__tHx6R","slide":"gallery_slide__64QEo","gallery2":"gallery_gallery2__YTvq1"};